/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
import Modal from "../../../../../components/common/Modal/Modal";
import Pagination from "../../../../../components/common/new/Pagination/Pagination";
import Typography from "../../../../../components/common/new/Typography/Typography";
import { Constants } from "../../../../../contants";
import { ATTENDANCE_COL } from "../../../../../contants/table/member";
import CardWithFooter from "../../../../member/components/CardWithFooter/CardWithFooter";
import { performOperation } from "../../../../member/MemberSearch/utils";
import {
  getAttendanceRows,
  getMaxRow,
  ROW_LIMIT,
  TABLE_TYPE,
  //   MAX_SIZE,
  getFormattedData,
  getFormattedFriends,
} from "../utils";
import styles from "./Styles";
import Friends from "../../../../../services/api/friend";
import Dropdown from "../../../../../components/common/new/Dropdown/Dropdown";
import NewTable from "../../../../member/components/Newtable/NewTable";

const MEETING_TYPE = [
  {
    value: "discussionMeeting",
    key: "Discussion Meeting",
  },
  {
    value: "goshoMeeting",
    key: "Gosho Meeting",
  },
  {
    value: "specialMeeting",
    key: "Special Meeting",
  },
  {
    value: "NHRMeeting",
    key: "NHR Meeting",
  },
  {
    value: "cubMeeting",
    key: "Cub Meeting",
  },
  {
    value: "FDMeeting",
    key: "FD Meeting",
  },
];

function AttendanceTabel({ meeting }) {
  return (
    <Box style={styles.attandenceTable}>
      <Typography
        component="p"
        weight={600}
        mb={4}
        style={{ color: "#607E9F", fontSize: "14px" }}
      >
        {meeting?.title}
      </Typography>
      <NewTable
        columns={ATTENDANCE_COL}
        tableHeadCellStyle={styles.tableHeadCell}
        rows={getAttendanceRows(meeting?.rows)}
        tableBodyTheme="#FFFFFF"
      />
    </Box>
  );
}

const getApi = () => {
  return Friends.getAttendanceByFriendId;
};

const getBeautifyData = (data, selectedTable) => {
  if (selectedTable === TABLE_TYPE.ATTENDANCE) {
    return getFormattedData(data);
  }
  return getFormattedFriends(data);
};

function ModalContent({ modalTitle, selectedTable, friendId }) {
  const [tableData, setTableData] = useState([]);
  const [paginationInfo, setPaginationInfo] = useState({});

  const fetchTableData = async (
    tableKey,
    page = 0,
    size = Constants.DEFAULT_PAGE_SIZE
  ) => {
    try {
      const { data } = await getApi(tableKey)({ friendId, page, size });

      setTableData(getBeautifyData(data.data ?? data.content, tableKey));
      setPaginationInfo({
        currentPage: Number(data.number),
        totalPages: Number(data.totalPages),
        totalElements: Number(data.totalElements),
        pageSize: Number(data.size),
      });
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const onPaginationClick = (page) => {
    const { pageSize } = paginationInfo;
    fetchTableData(selectedTable, page, pageSize);
  };

  const onPageSizeClick = (operator) => {
    const { pageSize } = paginationInfo;
    const newPageSize = performOperation(
      pageSize,
      Constants.DEFAULT_PAGE_SIZE,
      operator
    );
    fetchTableData(selectedTable, 0, newPageSize);
  };

  useEffect(() => {
    if (selectedTable) {
      fetchTableData(selectedTable);
    }
  }, [selectedTable]);

  return (
    <>
      <Typography
        component="p"
        weight={600}
        mb={4}
        variant="small"
        color="#8C8C8C"
      >
        {modalTitle}
      </Typography>
      <Box display="flex" gap="1rem">
        <AttendanceTabel meeting={tableData.goshoMeeting} />
        <AttendanceTabel meeting={tableData.discussionMeeting} />
        <AttendanceTabel meeting={tableData.specialMeeting} />
      </Box>

      <Box display="flex" justifyContent="center" mt={8}>
        <Pagination
          totalPages={paginationInfo.totalPages}
          totalResults={paginationInfo.totalElements}
          currentPage={paginationInfo.currentPage}
          pageSize={paginationInfo.pageSize}
          onChange={onPaginationClick}
          onPageSizeClick={onPageSizeClick}
        />
      </Box>
    </>
  );
}

function Dashboard({ friendId, attendanceInfo, friendInfo }) {
  const [openModal, setOpenModal] = useState(false);
  const [selectedTable, setSelectedTable] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  const {
    goshoMeeting,
    discussionMeeting,
    specialMeeting,
    NHRMeeting,
    cubMeeting,
    FDMeeting,
  } = attendanceInfo;
  const [meetingType, setMeetingType] = useState("discussionMeeting");
  const [meetingType1, setMeetingType1] = useState("goshoMeeting");
  const [meetingType2, setMeetingType2] = useState("specialMeeting");

  const toggleModal = () => setOpenModal((prev) => !prev);

  const onViewMoreHandler = (tableType, title) => {
    setModalTitle(title);
    setSelectedTable(tableType);
    toggleModal();
  };

  return (
    <>
      <Box style={styles.mainContainer}>
        <Box style={{ display: "flex" }}>
          <Box style={styles.main}>
            <Box style={styles.cardContainer} />
            <Box style={styles.cardContainer}>
              <CardWithFooter
                onViewMoreHandler={onViewMoreHandler}
                title="Attendance"
                mixHeight={210}
                mainContainerStyle={styles.attandence}
                tableType={TABLE_TYPE.ATTENDANCE}
                disableViewMore={
                  getMaxRow(attendanceInfo) <= ROW_LIMIT.ATTENDANCE
                }
                dropDown={
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <div style={{ width: "30%" }}>
                      <Dropdown
                        label="Select Meeting Type"
                        name={meetingType}
                        options={MEETING_TYPE}
                        value={meetingType}
                        onChange={(e) => {
                          setMeetingType(e.target.value);
                        }}
                      />
                    </div>

                    <div
                      style={{
                        display: "flex",
                        marginLeft: "auto",
                        width: "30%",
                      }}
                    >
                      <Dropdown
                        label="Select Meeting Type"
                        name={meetingType1}
                        options={MEETING_TYPE}
                        value={meetingType1}
                        onChange={(e) => {
                          setMeetingType1(e.target.value);
                        }}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        marginLeft: "auto",
                        marginRight: "2.2%",
                        width: "30%",
                      }}
                    >
                      <Dropdown
                        label="Select Meeting Type"
                        name={meetingType2}
                        options={MEETING_TYPE}
                        value={meetingType2}
                        onChange={(e) => {
                          setMeetingType2(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                }
              >
                <AttendanceTabel
                  meeting={
                    meetingType === "specialMeeting"
                      ? specialMeeting
                      : meetingType === "goshoMeeting"
                      ? goshoMeeting
                      : meetingType === "NHRMeeting"
                      ? NHRMeeting
                      : meetingType === "cubMeeting"
                      ? cubMeeting
                      : meetingType === "FDMeeting"
                      ? FDMeeting
                      : discussionMeeting
                  }
                  table1
                />
                <AttendanceTabel
                  meeting={
                    meetingType1 === "discussionMeeting"
                      ? discussionMeeting
                      : meetingType1 === "specialMeeting"
                      ? specialMeeting
                      : meetingType1 === "NHRMeeting"
                      ? NHRMeeting
                      : meetingType1 === "cubMeeting"
                      ? cubMeeting
                      : meetingType1 === "FDMeeting"
                      ? FDMeeting
                      : goshoMeeting
                  }
                  table2
                />
                <AttendanceTabel
                  meeting={
                    meetingType2 === "goshoMeeting"
                      ? goshoMeeting
                      : meetingType2 === "discussionMeeting"
                      ? discussionMeeting
                      : meetingType2 === "NHRMeeting"
                      ? NHRMeeting
                      : meetingType2 === "cubMeeting"
                      ? cubMeeting
                      : meetingType2 === "FDMeeting"
                      ? FDMeeting
                      : specialMeeting
                  }
                />
              </CardWithFooter>
            </Box>
          </Box>
        </Box>
      </Box>
      <Modal open={openModal} onClose={toggleModal} customStyle={styles.modal}>
        <ModalContent
          friendId={friendId}
          modalTitle={modalTitle}
          selectedTable={selectedTable}
          friendInfo={friendInfo}
        />
      </Modal>
    </>
  );
}

export default Dashboard;
